import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeService } from '../services/home.service';
import { DataLayerService } from '../services/data-layer.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../assets/style/css/owl.carousel.min.css','./home.component.css']
})
export class HomeComponent implements OnInit{
    apiUrl = environment.baseUrl
    createLeadForm:FormGroup
    nameValidateMessage: any = '';
    companyValidateMessage: string = '';
    emailValidateMessage: string = '';
    mobileValidateMessage: string = '';
    name:string =''
    company:string=''
    email:string=''
    mobile:string=''
    isThanksPageVisible:boolean=false
    formSubmitted:boolean = false;

  constructor(public formbuilder:FormBuilder,private http:HttpClient){
    this.createLeadForm = this.formbuilder.group({
        Name:['',[Validators.required]],
        Company:['',[Validators.required]],
        Email:['',[Validators.required,Validators.email]],
        Mobile:['',[Validators.required]]
    })

  }

  ngOnInit(): void {
    
}


  createLead(){
    if (this.createLeadForm.valid){
      const data = this.createLeadForm.value
      let params = new HttpParams()
      .set('Name', data.Name)
      .set('Company', data.Company)
      .set('Email', data.Email)
      .set('Mobile', data.Mobile);
      this.http.get(this.apiUrl+"GetInvestmentLead",{params}).subscribe((res:any)=>{
          console.log(res)
          this.createLeadForm.reset()
          this.formSubmitted = true;
      })        
    }else{
        alert("Please fill the form properly")
    }
  }


  
  




  checkValidationMsg(leadForm:any) {
    let num: number = 0;
    this.name = leadForm.value.Name.trim();
    this.email = leadForm.value.Email.trim();
    this.mobile = leadForm.value.Mobile.trim();
    this.company = leadForm.value.Company.trim();
   
    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }

    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    
    if (this.company && this.company.length < 3) {
        this.companyValidateMessage = "lengthError";
        num += 1;
    }
    if (!this.company) {
        this.companyValidateMessage = "required";
        num += 1;
    }
    if (this.email && this.validateEmailAddress() == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if(!this.email){  
          this.emailValidateMessage = "required";
          num+=1;
    }
    if (this.isMobileWrong() == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }


  }

  isMobileWrong() {
    let firstDigit = this.mobile.substr(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (this.mobile.match(/^(\d)\1+$/g)) {
      return 0;
    }
    else {
      return 1;
    }
  }

validateEmailAddress() {    
    if (this.email) {
      var lastChars = this.email.lastIndexOf(".");
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(this.email).toLowerCase()) || this.email.substr(lastChars, 3).length < 3) {
        return 0;
      }
      else {
        return 1;
      }
    }
    return 0; // Return 0 if this.email is falsy
}

  removeErrorMsg(fieldname:string) {
    if (fieldname=="name") {
      this.nameValidateMessage = "";
    }
    if (fieldname=="email") {
      this.emailValidateMessage = "";
    }
    if (fieldname=="mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname=="company") {
        this.companyValidateMessage = "";
      }
  }

alphaOnly(event:any) {
    var key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key == 32 || key == 8));
};

numbersOnly(event:any) {
    var key = event.keyCode;
    return ((key >= 47 && key <= 57) || key == 8);
};


}
